import {fetchApi} from "../fetch";
import {API_HOST, API_URL} from "../../constants/axios";


export const listPointUsers = async (page, search) => {
    const searchParam = new URLSearchParams({page});

    if (search) {
        searchParam.append('search', search);
    }
    const res = await fetchApi.get(`${API_URL.LIST_POINT}?${searchParam.toString()}`)
    return res.data;
}

export const savePoint = async (sales, point, phoneNumber, rate, entryPointUuid, isEncrypt) => {
    const res = await fetchApi.post(`${API_URL.SAVE_POINT}`, {
        sales: sales,
        point: point,
        phoneNumber: phoneNumber,
        rate: rate,
        entryPointUuid: entryPointUuid,
        isEncrypt: isEncrypt
    })
    return res.data;
}

export const usingPoint = async (point, phoneNumber, entryPointUuid, isEncrypt) => {
    const res = await fetchApi.post(`${API_URL.USE_POINT}`, {
        point: point,
        phoneNumber: phoneNumber,
        entryPointUuid: entryPointUuid,
        isEncrypt: isEncrypt
    })
    return res.data;
}

export const addUser = async (phoneNumber) => {
    const res = await fetchApi.post(`${API_URL.ADD_POINT_USER}?phoneNumber=${phoneNumber}`)
    return res.data;
}

export const getConfig = async () => {
    const res = await fetchApi.get(`${API_URL.POINT_CONFIG}`)
    return res.data;
}

export const getConfigMinPoint = async () => {
    const res = await fetchApi.get(`${API_URL.MIN_POINT_CONFIG}`)
    return res.data;
}

export const saveConfig = async (defaultPoint, pointType, benefitId, isNew, minPoint, usedVipConfig, vipConfig, expiredMonth, maxPoint, eventPoint) => {
    const res = await fetchApi.post(`${API_URL.POINT_CONFIG}`, {
        defaultPoint: defaultPoint,
        pointType: pointType,
        benefitId: benefitId,
        isNew: isNew,
        minPoint: minPoint,
        usedVipConfig: usedVipConfig,
        vipConfig: vipConfig,
        expiredMonth: expiredMonth,
        maxPoint: maxPoint,
        eventPoint: eventPoint
    })
    return res.data;
}

export const getUserPoint = async (phoneNumber) => {
    const res = await fetchApi.get(`${API_URL.GET_USER_POINT}?phoneNumber=${phoneNumber}`)
    return res.data;
}

export const notificationStream = (entrypointUuid) => {
    return fetchApi.source(`${API_HOST}/point/notification?entrypointUuid=${entrypointUuid}`);
}

export const getEntryPointList = async () => {
    const res = await fetchApi.get(`${API_URL.POINT_ENTRY_POINT_LIST}`)
    return res.data;
}

export const getPointList = async (phoneNumber, isEncrypt) => {
    const res = await fetchApi.get(`${API_URL.GET_USER_POINT_HISTORY}?phoneNumber=${phoneNumber}&isEncrypt=${isEncrypt}`)
    return res.data;
}

/*
  이 고객에게 **적용될 적립율**과 등급명. 매장 화면의 '적립 예정 포인트' 표시가 쓴다.

  🔴 왜 필요한가 (2026-08-27) — 적립율을 서버가 정하도록 바꿨다(`PointController.savePoint` 가
     `resolveEarnRate` 로 등급을 직접 조회한다). 그래서 프론트가 **채널 기본 적립율**로 계산한
     예상치는 등급이 붙은 고객에게 틀린 값이 된다. 실제 적립값과 같은 숫자를 보여주려면
     적용될 적립율을 서버에서 받아야 한다.

  ⚠️ 경로를 `API_URL` 이 아니라 여기에 직접 적었다 — `src/constants/axios.js` 를 **다른 트랙이
     동시에 수정 중**이어서 그 파일을 건드리면 서로의 미커밋 변경이 섞인다.
     그 트랙이 커밋된 뒤 `API_URL.GET_USER_EARN_RATE` 로 옮기는 것이 맞다.
*/
export const getEarnRate = async (phoneNumber) => {
    const res = await fetchApi.get(`/point/user/earn-rate?phoneNumber=${encodeURIComponent(phoneNumber)}`)
    return res.data;
}

export const customerPointRequest = async (spotUid, phoneNumber) => {
    const res = await fetchApi.post(`${API_URL.POINT_CUSTOMER_REQUEST}`, {
        spotUid, phoneNumber
    })
    return res.data;
}